const initialState = { 
  loading: false,
  success: null,
  error: null
}

function deleteProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'DELETE_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'DELETE_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default deleteProductReducer